"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationTable = void 0;
var react_table_1 = require("react-table");
require("./table.css");
var reactstrap_1 = require("reactstrap");
var React = require("react");
var react_paginate_1 = require("react-paginate");
var PaginationTable = function (props) {
    //const columns = useMemo(() => props.columns, [])
    //const data = useMemo(() => props.data, [])
    var columns = props.columns;
    var data = props.data;
    //const [currentPage, setCurrentPage] = useState(0);
    //const [data, setData] = useState([]);
    /*const getData = () => {
        axios.get('https://jsonplaceholder.typicode.com/todos').then((res) => {
            console.log(res.data);
            data = res.data;
        });
    };*/ ///
    var _a = react_table_1.useTable({
        columns: columns,
        data: data,
        initialState: { pageIndex: 0, pageSize: 5 }
    }, react_table_1.useFilters, react_table_1.usePagination), getTableProps = _a.getTableProps, getTableBodyProps = _a.getTableBodyProps, headerGroups = _a.headerGroups, page = _a.page, nextPage = _a.nextPage, previousPage = _a.previousPage, canNextPage = _a.canNextPage, canPreviousPage = _a.canPreviousPage, pageOptions = _a.pageOptions, pageCount = _a.pageCount, gotoPage = _a.gotoPage, setPageSize = _a.setPageSize, state = _a.state, prepareRow = _a.prepareRow;
    var pageIndex = state.pageIndex, pageSize = state.pageSize; //removed filterInput, setFilterInput
    // const [filterInput, setFilterInput] = useState("");
    // Update the state when input changed
    //const handleFilterChange = (e: any) => {
    //    const value = e.target.value || undefined;
    //    setFilter("show.name", value);
    //    setFilterInput(value);
    //}
    var paginationChange = function () {
        console.log(pageCount);
    };
    var handlePageClick = function (selectedItem) {
        gotoPage(selectedItem.selected);
    };
    // Input element
    // const { getTableProps, 
    //     getTableBodyProps, 
    //     headerGroups, 
    //     rows, 
    //     prepareRow 
    // } = tableInstance
    // getData{};
    return (React.createElement("div", null,
        React.createElement("div", { id: "search" }),
        React.createElement("div", { id: "showEntries" },
            React.createElement("span", null,
                "Show ",
                ' ',
                React.createElement("select", { value: pageSize, onChange: function (e) { return setPageSize(Number(e.target.value)); } }, [5, 10, 20].map(function (pageSize) { return (React.createElement("option", { key: pageSize, value: pageSize }, pageSize)); })),
                ' ',
                "Entries")),
        React.createElement(reactstrap_1.Table, __assign({}, getTableProps, { responsive: true }),
            React.createElement("thead", null, headerGroups.map(function (headerGroup) { return (React.createElement("tr", __assign({}, headerGroup.getHeaderGroupProps()), headerGroup.headers.map(function (column) { return (React.createElement("th", __assign({ scope: "row" }, column.getHeaderProps()), column.render('Header'))); }))); })),
            React.createElement("tbody", __assign({}, getTableBodyProps), page.map(function (row) {
                prepareRow(row);
                return (React.createElement("tr", __assign({}, row.getRowProps()), row.cells.map(function (cell) {
                    return React.createElement("td", __assign({}, cell.getCellProps()), cell.render('Cell'));
                })));
            }))),
        React.createElement("div", { id: "table-footer" },
            React.createElement("div", { id: "entriesShown" },
                React.createElement("span", null,
                    "Showing",
                    ' ',
                    pageIndex + 1,
                    " to ",
                    pageIndex + 1,
                    " of ",
                    pageSize,
                    ' ',
                    " entries ",
                    ' ')),
            React.createElement("div", { id: "pageButton" },
                React.createElement("div", null,
                    React.createElement(react_paginate_1.default, { previousLabel: "Previous ", nextLabel: " Next", breakLabel: "...", breakClassName: "break-me", pageCount: pageCount, marginPagesDisplayed: 1, pageRangeDisplayed: 2, onPageChange: handlePageClick, containerClassName: "pagination", pageLinkClassName: "pagination__link", previousLinkClassName: "pagination__link--previous", nextLinkClassName: "pagination__link--next", disabledClassName: "pagination__link--disabled", activeClassName: "pagination__link--active" }))))));
};
exports.PaginationTable = PaginationTable;
//# sourceMappingURL=PaginationTable.js.map